import { AUTHORIZATION_API_URL as API_URL } from '@/_constants';
import { NovatiqHttpClient } from '@/_http-client';
import { IUpdateRole, IUserRole } from '@/_types';
import { ICreateRole } from '@/features/administration/roles/user-roles-management/user-roles-management.model';
import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  private readonly http = inject(NovatiqHttpClient);

  getUserRoles(orgtypeid: number, roleId?: number): Observable<unknown> {
    let params = new HttpParams();
    if (roleId) {
      params = params.append('roleid', roleId.toString());
    }
    return this.http.get(`${API_URL.USER_ROLE}/${orgtypeid}`, params);
  }

  updateRole(roleId: number, functionResourceIds: number[]): Observable<unknown> {
    return this.http.put(`${API_URL.USER_ROLE}/${roleId}`, { functionResourceIds });
  }

  createRole(postData: ICreateRole): Observable<unknown> {
    return this.http.post(`${API_URL.USER_ROLE}`, postData);
  }

  updateUserRole(roleId: number, updatedRole: IUpdateRole): Observable<IUserRole> {
    return this.http.put<IUserRole>(`${API_URL.ACCESS_INFO}/${roleId}`, updatedRole);
  }

  deleteUserRole(roleId: number): Observable<IUserRole> {
    return this.http.delete<IUserRole>(`${API_URL.USER_ROLE}/${roleId}`);
  }

  updateModuleVisibility(orgTypeId: number, moduleVisibility: unknown): Observable<unknown> {
    return this.http.put(`${API_URL.ACCESS_INFO}/${API_URL.MODULE_VISIBILITY}/${orgTypeId}`, moduleVisibility);
  }
}
